import { useState } from "react";

export const useToolsScan = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleFinish = () => {
    setShowLoader(false);
    setShowResult(true);
  };

  return {
    showLoader,
    setShowLoader,
    showResult,
    setShowResult,
    inputValue,
    setInputValue,
    handleFinish,
  };
};
